<template>
  <div class="page">
    <div class="top-back">
      <!-- <div class="back" @click="black"><img src="@/assets/userNew/icon36.png"></div> -->
      <div class="code">{{ recordLoginText }}</div>
    </div>
    <div class="grille">
      <div class="grille-item" @click="toRecharge">
        <div class="img-1">
          <img src="@/assets/userNew/icon29.png" alt="">
        </div>
        <div class="icon-text">套餐订购</div>
      </div>
      <div class="grille-item" @click="toBalanceRecharge">
        <div class="img-1">
          <img src="@/assets/userNew/999.png" alt="">
        </div>
        <div class="icon-text">余额充值</div>
      </div>

      <div class="grille-item" @click="toKefu">
        <div class="img-1">
          <img src="@/assets/userNew/icon27.png" alt="">
        </div>
        <div class="icon-text">联系客服</div>
      </div>


      <div class="grille-item" @click="toSelectMa">
        <div class="img-1">
          <img src="@/assets/userNew/icon40.png" alt="">
        </div>
        <div class="icon-text">充值码</div>
      </div>

      <div class="grille-item" @click="toSheAuth" v-if="simInfo.allAuth == 1">
        <div class="img-1">
          <img src="@/assets/userNew/icon26.png" alt="">
        </div>
        <div class="icon-text">设备实名</div>
      </div>
      <div class="grille-item" v-else @click="toSupplierAuth">
        <div class="img-1">
          <img src="@/assets/userNew/icon26.png" alt="">
        </div>
        <div class="icon-text">实名认证</div>
      </div>

      <div class="grille-item" @click="toActive">
        <div class="img-1">
          <img src="@/assets/userNew/666.png" alt="">
        </div>
        <div class="icon-text">一键复机</div>
      </div>


      <div class="grille-item" v-if="simInfo.sheUrl && simInfo.sheUrl != '设备接口'" @click="toShebei()">
        <div class="img-1">
          <img src="@/assets/userNew/30.png" alt="">
        </div>
        <div class="icon-text">设备管理</div>
      </div>

      <div class="grille-item" v-else @click="buyCard()">
        <div class="img-1">
          <img src="@/assets/userNew/777.png" alt="">
        </div>
        <div class="icon-text">在线商城</div>
      </div>


      <div class="grille-item" @click="gotoMore">
        <div class="img-1">
          <img src="@/assets/userNew/icon28.png" alt="">
        </div>
        <div class="icon-text">更多</div>
      </div>
      <!-- 

      <div class="grille-item" @click="kfClick">
        <div class="img-1">
          <img src="@/assets/userNew/icon39.png" alt="">
        </div>
        <div class="icon-text">联系客服</div>
      </div>

     <div class="grille-item" @click="buyCard()">
        <div class="img-1">
          <img src="@/assets/home/27.png" alt="">
        </div>
        <div class="icon-text">在线购买</div>
      </div>

       <div class="grille-item" @click="outLogin">
        <div class="img-1">
          <img src="@/assets/userNew/icon48.png" alt="">
        </div>
        <div class="icon-text">退出登录</div>
      </div> -->

    </div>
    <div class="w upgrade">
      <div class="img"><img src="@/assets/userNew/icon38.png" alt=""></div>
      <div class="text">{{ simInfo.pkgName }}</div>
      <div class="el-btn" @click="toRecharge">立即订购</div>
    </div>
    <div class="allowance">
      <div class="el-cl-flex">
        <div class="zll">
          <div class="zll-num" v-if="simInfo.isNoLimitData == 1">无限量</div>
          <div class="zll-num" v-else>{{ fluxMtoG(simInfo.flowRate || 0) }}GB</div>
          <div class="zll-zh">总流量</div>
        </div>
        <div class="zll" v-if="simInfo.isNoLimitData == 0">
          <div class="zll-num">{{ fluxMtoG(simInfo.surplusFlowRate || 0) }}GB</div>
          <div class="zll-zh">剩余流量</div>
        </div>
        <div class="zll" v-if="simInfo.isNoLimitData == 1">
          <div class="zll-num">无限量</div>
          <div class="zll-zh">剩余流量</div>
        </div>

        <!-- <div class="zll">
          <div class="zll-num">{{ simInfo.endTimeDay || 0 }}天</div>
          <div class="zll-zh">账期剩余时长</div>
        </div> -->
        <div class="zll">
          <div class="zll-num">{{ simInfo.cardStateName }}</div>
          <div class="zll-zh">卡状态</div>
        </div>
        <div class="zll">
          <div class="zll-num">--</div>
          <div class="zll-zh zll-zh2" @click="isShow = !isShow">
            余额<van-icon :name="isShow ? 'arrow-down' : 'arrow-up'" />
          </div>
        </div>
      </div>
      <div v-if="isShow" class="balanceBox">
        <div class="balance-item">
          <div class="balance-icon">
            <img src="@/assets/userNew/icon30.png" alt="">
          </div>
          <div class="text12-view">卡余额：</div>
          <div class="text-num">
            ￥{{ money_format(userAccount.amount / 100, 2, ".", ",") * 1 }}
          </div>
          <div class="text-link" @click="toBalanceRecharge">立即充值</div>
        </div>
        <!-- <div class="balance-item">
          <div class="balance-icon">
            <img src="@/assets/userNew/icon33.png" alt="">
          </div>
          <div class="text12-view">活动余额：</div>
          <div class="text-num">￥{{ simInfo.userPriceAmount }}</div>
          <div class="text-link" @click="detailsTo">查询明细</div>
        </div> -->

        <div class="balance-item">
          <div class="balance-icon">
            <img src="@/assets/userNew/icon31.png" alt="">
          </div>
          <div class="text12-view">实名状态：</div>
          <div class="text-num">{{ isAuthName }}</div>
          <div class="text-link" v-if="isAuthName != '已实名'" @click="toSupplierAuth">前往实名</div>
        </div>

        <div class="balance-item">
          <div class="balance-icon">
            <img src="@/assets/userNew/icon32.png" alt="">
          </div>
          <div class="text12-view">过期时间：</div>
          <div class="text-num">{{ simInfo.endTimeString }}</div>
          <div class="text-link" @click="toRecharge">充值套餐</div>
        </div>


      </div>
      <div class="btn-link">
        <img src="@/assets/userNew/8.png" alt="" @click="gotoView">
      </div>
    </div>
    <div class="allowance w">
      <div class="t">
        <!-- <div class="t-img">
          <img src="@/assets/userNew/9.png" alt="">
        </div> -->
        <div class="hit">热门活动 |</div>
        <div class="hit1">热门畅销 为你精选</div>
      </div>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item @click="toUrlLoad">
          <img v-if="newHomeImg && newHomeImg != null && newHomeImg != 'null' && newHomeImg != ''" :src="newHomeImg"
            alt="">
          <img v-else src="@/assets/userNew/icon34.png" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>


    <van-dialog v-model="isShowAuth" title="实名认证提示" :show-confirm-button="false">
      <div class="dialog-text">
        根据国家规定，手机卡需要进行实名认证，实名认证后方可使用。
      </div>
      <div class="dialog-text">
        如果您已操作实名认证，无需重复操作，重启手机后即可畅享网络。
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toSupplierAuth">立即实名</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="isShowPrice" title="套餐订购提示" :show-confirm-button="false">
      <div class="dialog-text">
        您已成功参与购买优惠券活动,每个月购买套餐可自动抵扣金额，订购套餐后即可畅享网络。
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toRecharge()">立即订购</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="isChangeCard" title="换卡通知" :show-confirm-button="false">
      <div class="dialog-text">
        {{ huanRemark }}
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toChangeCard">去换新卡</van-button>
      </div>
    </van-dialog>




    <van-dialog v-model="isShowYueHuodong" title="预存送优惠券活动" :show-confirm-button="false">
      <div class="dialog-text">限时预存活动！充值账户余额 可免费多得优惠券！ 最高可直接减免套餐金额！</div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toYueHuodong">去看看</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="appshowimg" title="保存充值码" confirmButtonColor="#86de6b" confirmButtonText="知道了">
      <div style="font-size: 18px;padding-top:6px;text-align: center;font-weight: bold;">卡号 {{ simInfo.virtualNo }}
      </div>
      <img style="width: 100%" :src="imgUrl" />
      <div style="font-size: 14px;color:#999;padding-top:6px;text-align: center;">截图保存二维码,后期可直接扫码充值</div>
    </van-dialog>




  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant'
export default {
  data() {
    return {
      showLoadTitle: localStorage.getItem("isShowApp") == 1 ? true : false,
      isShowLoad: localStorage.getItem("isShowApp"),


      newHomeImg: localStorage.getItem("newHomeImg"),
      newHomeUrl: localStorage.getItem("newHomeUrl"),

      isAuth: localStorage.getItem("isAuth"),
      isAgentLogin: localStorage.getItem("isAgentLogin"),
      yucun: localStorage.getItem("yucun"),
      isSale: localStorage.getItem("isSale"),
      shebeiLogin: localStorage.getItem("shebeiLogin"),
      ishavePkg: localStorage.getItem("ishavePkg"),
      ishavePrice: localStorage.getItem("ishavePrice"),
      kefuUrl: localStorage.getItem("kefuUrl"),


      isChangeCard: false,
      isAuthName: '未实名/未知', //实名状态
      isShowAuth: false,

      appshowimg: false,
      canChangeCard: false,
      userAccount: {},
      simInfo: {},
      show: false,
      reacheShow: false,
      reacheShows: false,
      isShow: true,
      iccid: localStorage.getItem('iccid'),
      recordLoginText: localStorage.getItem('recordLoginText'),
      isNewPage: localStorage.getItem('isNewPage'),
      alreadyHasAccount: false,



      ctccAuthShow: false,
      cmccXxtx: false,
      cuccAuthShow: false,
      cmccAuthShow: false,
      otherAuth: false,
      otherUrl: '',
      isShowPrice: false,

      isShowYueHuodong: false,


      appshowimg: false,
      imgUrl: '',

      ctcc5GAuth: false,
      ctccJieAuth: false,

      guangdianAuth: false,
      ctccPhoneAuth: false,

      huanRemark:'',

    }
  },
  async created() {
    await wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem("iccid"), intoNo: localStorage.getItem("intoNo") }, "post").then((res) => {
      if (res.data.code == 200) {
        this.isAuthName = "已实名";
      } else if (res.data.code == 302) {
        this.isAuthName = "请先购买套餐";
      }
      sessionStorage.setItem("alreadyCertification", "true");
    });
    await this.getUserSimInfo();
    await this.getAccount();
    /**   换卡判断       **/
    let fd = new FormData();
    fd.append("iccid", localStorage.getItem("iccid"));
    await wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
      if (res.data.code == "200") { //换卡提醒
        this.isChangeCard = true;
        this.huanRemark=res.data.data.remark;
        localStorage.setItem('isTochangeCard', 1)
      } else if (
        this.isSale > 0 &&
        this.ishavePkg == 0 &&
        this.ishavePrice == 1 &&
        this.isAuthName == '请先购买套餐'
      ) {
        this.isShowPrice = true;
      } else if (this.isAuthName == '未实名/未知') {
        this.isShowAuth = true;
      } else {
        var data = {
          iccid: this.$store.state.iccid
        }
        wxRequest("sim/user/soldPkg/next/pkg", data, "get").then(res => {
          if (res.data.code == 200) {
            Dialog.alert({
              title: '温馨提示',
              message: res.data.message
            })
          }
        })
      }
    });
  },
  methods: {
    toSheAuth() {
      if (this.simInfo.flowRate && this.simInfo.flowRate > 0) {
        this.$router.push({ path: '/user/shebeiAuth', query: { iccid: this.$store.state.iccid } })
      } else {
        Dialog.alert({
          title: '温馨提示',
          message: '请先购买有效套餐后  再来实名！'
        })
      }
    },


    toShebei() {
      window.location.href = this.simInfo.sheUrl;
    },
    toSelectMa() {
      wxRequest("sim/get/invent/ma", { iccid: this.$store.state.iccid }, "post").then(res => {
        if (res.data.code == '200') {
          if (res.data.data) {
            this.imgUrl = res.data.data;
            this.appshowimg = true;
          }

        } else {
          Dialog.alert({
            title: '温馨提示',
            message: res.data.message
          });
        }
      })
    },



    buyCard() {
      wxRequest(
        "applyChangeSim/select/agent/buy/power",
        {
          oldIccid: localStorage.getItem("iccid"),
        },
        "post"
      ).then((res) => {
        if (res.data.code == 200) {
          this.$router.push("/user/liuliangka?agentId=" + this.simInfo.agentId);
        } else {
          Dialog.alert({
            message: res.data.message,
          });
        }
      });
    },

    toActive() {
      wxRequest("sim/to/active", { iccid: localStorage.getItem('iccid') }, 'get').then(res => {
        Dialog.alert({ message: res.data.message })
      })
    },
    toLoadApp() {
      localStorage.setItem("isShowApp", 2)
      this.$router.push('/user/AppALoad')
    },


    toUrlLoad() {
      if (!this.newHomeUrl || this.newHomeUrl == '购卡' || this.newHomeUrl == 'null') {
        this.$router.push("/user/liuliangka?agentId=" + this.simInfo.agentId);
      } else {
        window.location.href = this.newHomeUrl;
      }
    },
    toKefu() {
      wxRequest("sim/get/kefuUrl", {}, "post").then(res => {
        if (res.data.data) {
          window.location.href = res.data.data;
        } else {
          Dialog.alert({ title: "提示", message: '客服即将上线！如有其它疑问，请点更多->常见问题中寻找帮助' });
        }
      })

    },
    toDiejiaun() {
      this.$router.push("/user/huodong2");
    },
    toYueHuodong() {
      this.$router.push("/user/huodong");
    },
    cancelChange() {
      this.isShowYueHuodong = false,
        this.isShowAuth = false;
      this.isChangeCard = false;
      this.isShowPrice = false;
    },
    toChangeCard() {
      this.$router.push({
        name: "userChgCard",
        query: {
          oldIccid: localStorage.getItem("iccid")
        },
      });
    },
    getUserSimInfo() {
      wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then(
        (res) => {
          if (res.data.code == 200) {
            let result = res.data.data;
            if (result.flowRatePool == "电信") {
              this.ctccAuthShow = true;
            } else if (result.flowRatePool == "电信接口") {
              this.ctccJieAuth = true;
            } else if (result.flowRatePool == "5G电信") {
              this.ctcc5GAuth = true;
            } else if (result.flowRatePool == "联通") {
              this.cuccAuthShow = true;
            } else if (result.flowRatePool == "前海") {
              this.qianhaiSHow = true;
            } else if (result.flowRatePool == "移动") {
              this.cmccAuthShow = true;
            } else if (result.flowRatePool == "乐语") {
              this.leyuAuthShow = true;
            } else if (result.flowRatePool == "移动接口") {
              this.cmccXxtx = true;
            } else if (result.flowRatePool == '广电') {
              this.guangdianAuth = true;
            } else if (result.flowRatePool == '电信号卡') {
              this.ctccPhoneAuth = true;
            } else {
              this.otherUrl = result.flowRatePool;
              this.otherAuth = true;
            }
            localStorage.setItem('simInfoMap', result);
            sessionStorage.setItem("supplierCode", result.supplierCode);

            this.simInfo = result;

            if (result.simPackageList.length > 1) {
              for (let i = 0; i < result.simPackageList.length; i++) {
                if (
                  result.simPackageList[i].flowRatePercent &&
                  (result.simPackageList[i].flowRatePercent / 100) *
                  result.simPackageList[i].flowRate >
                  result.simPackageList[i].usedFlowRate
                ) {
                  this.simInfo.packageName =
                    result.simPackageList[i].packageName;
                  this.simInfo.endTime = result.simPackageList[i].endTime;
                  break;
                }
              }
            } else if (result.simPackageList.length == 1) {
              this.simInfo.packageName = result.simPackageList[0].packageName;
              this.simInfo.endTime = result.simPackageList[0].endTime;
            }
            this.simInfo.simId = this.simInfo.simPackageList[0]
              ? this.simInfo.simPackageList[0].simId
              : "";
          }
        }
      );
    },
    getAccount() {
      let param = {
        iccid: this.$store.state.iccid,
        mobile: localStorage.getItem("mobile"),
      };
      wxRequest("sysUser/account/querySysUserAccount", param, "post").then(
        (res) => {
          if (res.data.code == 200) {
            this.userAccount = res.data.data;
            this.alreadyHasAccount = true;
            localStorage.setItem("userSimAmount", this.userAccount.amount)
            localStorage.setItem('alreadyHasAccount', 1);
          } else {
            localStorage.setItem("userSimAmount", 0);
            localStorage.setItem('alreadyHasAccount', 0);
          }
        }
      );
    },
    toSupplierAuth() {
      if (this.isAuthName == '已实名') {
        Dialog.alert({ title: "提示", message: '已完成实名认证，无需再次实名！' });
      } else if (this.isAuthName == '请先购买套餐') {
        Dialog.confirm({
          message: "尊敬的用户你好，请先购买套餐后 再进行实名操作",
          confirmButtonText: "去购买",
          cancelButtonText: "取消",
        }).then(() => {
          this.$router.replace('/userNew/recharge');
        })
          .catch(() => { });
      } else {
        if (this.cmccXxtx == true) {
          wxRequest(
            "wxAuth/cmcc/auth",
            { iccid: this.$store.state.iccid },
            "post"
          ).then((res) => {
            if (res.data.code == "200") {
              window.location.href = res.data.data;
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.message,
              });
            }
          });
        } else if (this.ctccAuthShow == true) {
          this.$router.push({
            path: "/user/ctccAuth",
            query: { realNameCard: 1 },
          });
        } else if (this.cuccAuthShow == true) {
          window.location.href = "http://jilimao.anqingzhiyun.com/#/user/cuccAuth/?iccid="+this.$store.state.iccid;;
        } else if (this.cmccAuthShow == true) {
          this.$router.push({
            path: "/user/cmccAuth",
            query: { realNameCard: 1 },
          });
        } else if (this.ctcc5GAuth == true) {
          wxRequest(
            "wxAuth/ctcc/to/5G/auth",
            { iccid: this.$store.state.iccid },
            "post"
          ).then((res) => {
            if (res.data.code == "200") {
              window.location.href = res.data.data;
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.message,
              });
            }
          });
        } else if (this.ctccJieAuth == true) {
          wxRequest(
            "wxAuth/ctcc/to/auth",
            { iccid: this.$store.state.iccid },
            "post"
          ).then((res) => {
            if (res.data.code == "200") {
              window.location.href = res.data.data;
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.message,
              });
            }
          });
        } else if (this.guangdianAuth == true) {
          this.$router.push('/user/ctccGdAuth');
        } else if (this.ctccPhoneAuth == true) {
          this.$router.push('/user/ctccPhoneAuth');
        }
        else {
          if (this.otherUrl.indexOf("?") >= 0) {
            window.location.href = this.otherUrl + "&cn=" + this.simInfo.iccid + "&iccid=" + this.simInfo.iccid + "&cardno=" + this.simInfo.iccid;
          } else {
            window.location.href = this.otherUrl + "?cn=" + this.simInfo.iccid + "&iccid=" + this.simInfo.iccid + "&cardno=" + this.simInfo.iccid;
          }
        }

      }
    },
    toRecharge() {
      let fd = new FormData();
      fd.append("supplierId", sessionStorage.getItem("supplierCode"));
      wxRequest("sim/invent/state", fd, "post").then((res) => {
        if (res.data.code == 200) {
          if (this.userAccount.amount < 0) {
            Dialog.confirm({
              title: "提示",
              message: "您的账户余额已透支，请先充值账户余额！",
            })
              .then(() => {
                this.$router.push({
                  path: "/user/balanceRecharge",
                  query: {
                    iccid: this.$store.state.iccid,
                  },
                });
              })
              .catch(() => { });
          } else {
            this.$router.push({
              path: "/userNew/recharge",
              query: {
                iccid: this.$store.state.iccid,
              },
            });

          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.message,
          });
        }
      });

    },
    toBalanceRecharge() {
      if (this.yucun == 1 || this.yucun == 888) {
        this.$router.push({
          path: "/user/huodong",
          query: {
            iccid: this.$store.state.iccid,
          },
        });
      } else {
        this.$router.push({
          path: "/user/balanceRecharge",
          query: {
            iccid: this.$store.state.iccid,
          },
        });
      }


    },
    gotoMore() {
      this.$router.push({
        path: '/userNew/operation'
      })
    },
    detailsTo() {
      this.$router.push({
        name: "applySalePkg",
        query: { iccid: this.simInfo.iccid },
      });

    },
    gotoView() {
      this.$router.push({
        path: '/userNew/diagnosis'
      })
    }


  }
}
</script>
<style lang="less" scoped>
div {
  display: flex;
  flex-grow: 0;
  flex-basis: auto;
  align-items: stretch;
  flex-direction: column;
}

.w {
  width: 90%;
}

.page {
  background: #f7f8fa url("../../assets/userNew/icon37.png") no-repeat;
  background-position: 0% 0%;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;

  .top-back {
    flex-direction: row;
    align-items: center;
    height: 60px;
    display: flex;
    text-align: center;
    font-size: 17px;
    color: rgb(6, 18, 30);
    font-weight: bold;

    .back {
      align-items: center;
      width: 60px;

      img {
        width: 20px;
      }
    }

    .code {
      // width: calc(100% - 40px);
      width: 100%;
    }
  }

  .grille {
    display: flex;
    align-self: center;
    flex-direction: row;
    margin: 10px auto;
    background-color: hsla(0, 0%, 100%, 0.3);
    border-radius: 16px;
    align-content: flex-start;
    flex-wrap: wrap;
    width: 90%;

    .grille-item {
      // min-width: 84px;
      width: 25%;
      margin: 10px 0px 10px;
      align-items: center;

      .img-1 {
        width: 46px;
        height: 46px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .icon-text {
        font-size: 12px;
        font-weight: 700;
        color: #3d444d;
        margin-top: 5px;
      }
    }
  }

  .upgrade {
    align-self: center;
    flex-direction: row;
    margin-top: 5px;
    background-color: #fff;
    height: 40px;
    align-items: center;
    border-radius: 7px;

    .img {
      height: 15px;
      margin-right: 7px;
      width: 62px;
      margin-left: 16px;

      img {
        height: 100%;
      }
    }

    .text {
      font-size: 14px;
      color: #06121e;
      flex: 1;
    }

    .el-btn {
      padding: 4px 8px;
      border-radius: 200px;
      margin-right: 5px;
      background-color: #f9f5dc;
      font-size: 13px;
      font-weight: 500;
      color: #d8982e;
      border: 0;
    }
  }

  .allowance {
    align-self: center;
    flex-direction: column;
    margin-top: 15px;
    justify-content: center;
    background: #fff;
    border-radius: 20px;
    padding: 10px;
    width: 87%;

    .el-cl-flex {
      width: 320px;
      flex-direction: row;
      justify-content: space-around;
      margin-top: 7px;

      .zll {
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .zll-num {
        font-size: 22px;
        line-height: 22px;
        font-weight: 600;
        color: #06121e;
        text-align: center;
        margin-top: 10px;
      }

      .zll-zh {
        font-size: 12px;
        color: #8c9198;
        text-align: center;
        margin-top: 3px;
        margin-bottom: 15px;
      }

      .zll-zh2 {
        text-align: center;
        background: #4eb258;
        padding: 4px 8px;
        border-radius: 200px;
        flex-direction: row;
        font-size: 12px;
        color: #fff;
        text-align: center;
      }
    }

    .balanceBox {
      display: flex;
      flex-direction: column;
      background: #f7f8fa;
      border-radius: 8px;
      position: relative;
      margin-top: 5px;
      padding: 0 15px 15px;

      .balance-item {
        flex: 1;
        display: flex;
        flex-direction: row;
        margin-top: 15px;

        .balance-icon {
          width: 18px;
          height: 18px;
          margin-right: 5px;

          img {
            height: 100%;
            width: 100%;
          }
        }

        .text12-view {
          flex: 1;
        }

        .text-num {
          font-size: 13px;
          color: #06121e;
          font-weight: 700;
        }

        .text-link {
          font-size: 13px;
          font-weight: 500;
          color: #1c96f6;
          text-decoration: underline;
          margin-left: 15px;
        }
      }
    }

    .btn-link {
      height: 78px;
      width: 90%;
      margin: 0 auto;

      img {
        width: 100%;
      }
    }

    .t {
      display: flex;
      flex-direction: row;
      width: 320px;
      align-items: center;
      margin-bottom: 5px;

      .t-img {
        width: 26px;
        height: 26px;
      }

      .hit {
        color: #06121e;
        font-size: 16px;
      }

      .hi1 {
        color: rgb(6, 18, 30);
        font-size: 13px;
      }
    }

    .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 20px;
      line-height: 91px;
      text-align: center;
    }
  }
}

.van-dialog {
  ::v-deep.van-dialog__content {
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
  }

  ::v-deep .van-dialog__header {
    font-size: 20px;
    font-weight: 700;
    color: #06121e;
    text-align: center;
    margin-bottom: 10px;
  }

  .dialog-text {
    font-size: 14px;
    color: #06121e;
    margin-top: 8px;
    line-height: 28px;
  }

  .btn-vis {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 25px;

    .dialog-btn2 {
      width: 120px;
      height: 47px;
      color: #3476fe;
      text-align: center;
      background: rgba(52, 118, 254, 0.1) !important;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
    }

    .dialog-btn3 {
      width: 130px;
      height: 47px;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
      border: 0;
      color: #fff;
      background: #3476fe;
      text-align: center;
    }
  }
}
</style>
